import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    //const carId = this.element.getAttribute("data-car-id");
    //const source = this.element.getAttribute("data-source");
    //this.form = document.getElementById(`c-lead-form-${carId}-${source}`);
    //console.log(this.form);
    let _this = this;
    _this.emailSubmit = this.element.querySelector(".email-submit");
    _this.tos = this.element.getElementsByClassName('c-checkbox__tos');

    _this.tos.forEach((item)=> {
      console.log(item);
      item.addEventListener('change', function(e){
        if (item.checked  ){
          _this.emailSubmit.disabled = null;
        } else {
          _this.emailSubmit.disabled = "disabled";
        }
      });
    });
  }

  showModal() {
    const carId = this.element.getAttribute("data-car-share-id");
    const elem = document.getElementById(`car-share-${carId}`);
    elem.style.display = 'block';
  }

  closeModal() {
    const carId = this.element.getAttribute("data-car-share-id");
    const elem = document.getElementById(`car-share-${carId}`);
    elem.style.display = 'none';
  }
}